import { useEffect, useState } from 'react';
import { MortgageDirectoryClient, bundledMortgageLookups } from '@ourbranch/mortgage-directory';
import config from 'aws-exports';

// Reads the shared Branch-owned mortgage-lender directory (issue #34139) at runtime.
// Starts from the bundled snapshot so the first render matches today's behavior, then
// refreshes from the core-resources API (same X-Api-Key browser call pattern staff-fe
// already uses for affinity lookups). Any failure keeps the bundled snapshot.
export function useMortgageLookups() {
  const [mortgageLookups, setMortgageLookups] = useState(bundledMortgageLookups);

  useEffect(() => {
    let active = true;
    try {
      const client = new MortgageDirectoryClient({
        baseUrl: config.coreResourcesEndpoint || '',
        apiKey: config.coreResourcesApiKey
      });
      client
        .getMortgageLookups()
        .then((lookups) => {
          if (active && Array.isArray(lookups) && lookups.length) {
            setMortgageLookups(lookups);
          }
        })
        .catch(() => {
          /* keep the bundled snapshot */
        });
    } catch {
      /* no fetch / missing config: keep the bundled snapshot */
    }
    return () => {
      active = false;
    };
  }, []);

  return mortgageLookups;
}
